<template>
  <span v-if="model" style="display: flex">
    <v-text-field :value="model.filename" v-bind="$attrs">
      <template v-slot:prepend>
        <v-btn
          icon="mdi-download"
          variant="plain"
          density="compact"
          @click="model.download()"
        >
        </v-btn>
      </template>
      <template v-slot:append>
        <v-btn
          :disabled="disabled"
          icon="mdi-close"
          variant="plain"
          density="compact"
          @click="model = null"
        >
        </v-btn>
      </template>
    </v-text-field>
  </span>
  <span v-else>
    <FileUpload v-bind="$attrs" @upload="model = $event" />
  </span>
</template>

<script lang="ts" setup>
import { defineModel } from "vue";
import { DBFile } from "@/classes";
import FileUpload from "@/components/base/inputs/FileUpload.vue";

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

const model = defineModel<DBFile | null>();
</script>

<style lang="scss" scoped></style>
